import { LitElement, css, html } from 'lit'
import { customElement } from 'lit/decorators.js';
import { router } from '../router';
import './../components/header.js';
import './../pages/nav-bar/nav-bar.wc.js';
@customElement('vt-shell')
export class Shell extends LitElement {

    private _lastPath = window.location.pathname;
    private _pendingDirection: 'forward' | 'backward' = 'forward';

    static get styles() {
        return css`
         /* css */
                :host {
                    display: grid;
                    grid-template-rows: auto 1fr auto; /* Header, Main Router Slot, Bottom Nav */
                    width: 100vw;
                    height: 100vh;
                    position: relative;
                    overflow: hidden;
                    background-color: #121212; /* <-- ADD THIS LINE */
                }
                main {
                    position: relative;
                    width: 100%;
                    height: 100%;
                    grid-row: 2;
                    background-color: #121212; /* <-- ADD THIS LINE */
                }
                `
    }

    connectedCallback() {
        super.connectedCallback();
        router.addEventListener('route-changed', this._handleRouteChange);
        window.addEventListener('popstate', this._handlePopState);
    }

    disconnectedCallback() {
        super.disconnectedCallback();
        router.removeEventListener('route-changed', this._handleRouteChange);
        window.removeEventListener('popstate', this._handlePopState);
    }

    render() {
        return html`
        <app-header title="javi.adv" ?enableBack=${this._lastPath !== '/'}></app-header>
        <main id="stage">
            ${router.render()}
        </main>
        <app-nav-bar></app-nav-bar>
        `;
    }

    private _handlePopState = () => {
        this._pendingDirection = 'backward';
    }

    private _handleRouteChange = async () => {
        const nextPath = window.location.pathname;
        if (nextPath === this._lastPath) return;

        const direction = this._pendingDirection;
        this._pendingDirection = 'forward';

        if (!("startViewTransition" in document)) {
            this._lastPath = nextPath;
            this.requestUpdate();
            return;
        }

        document.documentElement.setAttribute('data-transition-direction', direction);

        const transition = (document as any).startViewTransition(() => {
            this._lastPath = nextPath;
            this.requestUpdate();
        });

        try {
            await transition.finished;
        } finally {
            document.documentElement.removeAttribute('data-transition-direction');
        }
    }
}